import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowLeftFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 18.842c0 1.03-1.224 1.545-1.94.817l-6.727-6.842a1.17 1.17 0 0 1 0-1.634L14.06 4.34c.716-.728 1.94-.213 1.94.817v13.684Z", fill: color }));
};
export default factorySvgIcon(SvgArrowLeftFilled);
//# sourceMappingURL=SvgArrowLeftFilled.js.map